import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { DELETEACTIVE_MACHINES } from '@custom/constant';

// Create the async thunk
export const deleteMachine = createAsyncThunk(
  'machines/deleteMachine',
  async (id: string) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await axios.delete(DELETEACTIVE_MACHINES, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        data: { _id: id } // Pass id in the request body
      });

      return response.data; // Return the response data
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to delete the machine');
    }
  }
);
